/* istanbul ignore file */
import { number as codecNumber, string as codecString } from 'purify-ts/Codec';
import { utils as coreUtils } from '@codegrade/api-core';
import { parsers } from '@codegrade/utils';
const AutoTestGlobalSetupOutputParser = 
/* #__PURE__ */ parsers.object([
    ['cmd', /* #__PURE__ */ parsers.maybeNull(codecString)],
    ['stdout', codecString],
    ['stderr', codecString],
    ['timeSpend', /* #__PURE__ */ parsers.maybeNull(parsers.duration), 'time_spend'],
    ['exitCode', /* #__PURE__ */ parsers.maybeNull(codecNumber), 'exit_code'],
]);
export class AutoTestGlobalSetupOutput extends /* #__PURE__ */ coreUtils.AssigningBase {
    static decode(input) {
        return AutoTestGlobalSetupOutputParser.decode(input).map(res => new AutoTestGlobalSetupOutput(res));
    }
    static unsafeDecode(input) {
        return AutoTestGlobalSetupOutput.decode(input).unsafeCoerce();
    }
    static encode(data) {
        return AutoTestGlobalSetupOutputParser.encode(data);
    }
    static schema() {
        return AutoTestGlobalSetupOutputParser.schema();
    }
}
